export function tooltipFunc() {
    let $openBtn = $(".discount-tooltip-outer > button");

    if ($openBtn.length) {

        let $tooltip = $(".discount-tooltip");
        let $win = $(window);
        let $body = $("body");
        let eventType = "click";
        let $modalInner = $(".cart-modal-title");

        if ($win.width() > 568) {
            if ($openBtn.position().left > $modalInner.width() / 2) {
                $tooltip.css({
                    "top": $openBtn.offset().top + $openBtn.innerHeight() + 12 +"px",
                    "left": "auto",
                    "right": 60 + "px",
                });
            } else {
                $tooltip.css({
                    "top": $openBtn.offset().top + $openBtn.innerHeight() + 12 +"px",
                    "left": "auto",
                    "right": $modalInner.width() - $tooltip.innerWidth() + "px",
                });
            }
        }

        if ($win.width() > 1200) {
            eventType = "mouseover";
        }

        $openBtn.on(eventType, function () {
            $(this).addClass("show-arrow");

            $tooltip.addClass("show");
        }).on("mouseleave", function () {
            $tooltip.removeClass("show");
            $(this).removeClass("show-arrow");
        });

        $body.on("click", function (e){

            if (!$openBtn.is(e.target)
                && $openBtn.has(e.target).length === 0) {
                $openBtn.removeClass("show-arrow");
                $tooltip.removeClass("show");
            }
        });

        $win.on("resize", function () {

            if ($win.width() > 568) {
                if ($openBtn.position().left > $modalInner.width() / 2) {
                    $tooltip.css({
                        "top": $openBtn.offset().top + $openBtn.innerHeight() + 12 +"px",
                        "left": "auto",
                        "right": 60 + "px",
                    });
                } else {
                    $tooltip.css({
                        "top": $openBtn.offset().top + $openBtn.innerHeight() + 12 +"px",
                        "left": "auto",
                        "right": $modalInner.width() - $tooltip.innerWidth() + "px",
                    });
                }
            } else {
                $tooltip.css({
                    "top": $openBtn.innerHeight() + 12 +"px",
                    "left": "auto",
                    "right": 0 + "px",
                });
            }
        });
    }
};


// WEBPACK FOOTER //
// ./assets/js/modules/tooltip.js